const COLORS = {
  safe: "#00E5FF",
  warning: "#FF9900",
  critical: "#FF2A55",
  expired: "#FF2A55",
  paused: "#FF9900",
};

const StatusDot = ({ statusKey = "safe" }) => {
  const color = COLORS[statusKey] || COLORS.safe;
  return (
    <span className="relative inline-flex items-center justify-center" data-testid="status-dot">
      <span
        className="block w-2.5 h-2.5 rounded-full"
        style={{ background: color, boxShadow: `0 0 14px ${color}` }}
      />
      <span
        className="absolute w-4 h-4 rounded-full opacity-50 animate-ping"
        style={{ background: color }}
      />
    </span>
  );
};

export default StatusDot;
